<template>
  <div>
  <span>{{formatDate(data.date)}}</span>

  </div>
</template>

<script>
export default {
  name: "dateColumn",
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    formatDate(date) {
      return this.$moment(date).format('DD.MM.YY HH:mm');
    }
  }
}
</script>

<style scoped>

</style>
